import { FormSectionTitle } from '../atoms/FormSectionTitle';
import { LineAddFriendLink } from 'atoms/LineAddFriendLink';

type LabelLineAddFriendFieldProps = {
  title: string;
  description: string;
  unlinkDescription: string;
  linkStatus: string;
  linkedText: string;
  notLinkedText: string;
  unlinkAnchorText: string;
  isLinkedLine: boolean;
  onOpenModal: () => void;
};

export const LabelLineAddFriendField = (props: LabelLineAddFriendFieldProps) => {
  const {
    title,
    description,
    unlinkDescription,
    linkStatus,
    linkedText,
    notLinkedText,
    unlinkAnchorText,
    isLinkedLine,
  } = props;
  return (
    <div>
      <FormSectionTitle text={title} />
      {!isLinkedLine && <p className="text-[--c-text] pt-[10px]">{description}</p>}
      <p className="text-[--c-text] pt-[10px]">
        {linkStatus} : {isLinkedLine ? linkedText : notLinkedText}
      </p>
      <div className="pt-[10px]">
        <LineAddFriendLink href={`${process.env.REACT_APP_LINE_LINK}`} alt={title} />
      </div>
      {isLinkedLine && (
        <div>
          <p className="text-[--c-text] pt-[10px]">{unlinkDescription}</p>
          <p
            className="text-[--c-secondary-color2] pt-[10px] cursor-pointer"
            onClick={props.onOpenModal}
          >
            {unlinkAnchorText}
          </p>
        </div>
      )}
    </div>
  );
};
